import React from "react";
import "./PriceChart.css";
import ChartComponent from "./ChartComponent";


const PriceChart = () => {
  return (
    <div className="price-chart-outer-cont">
      <div className="price-chart-head">
        <h3>RTM Price Chart</h3>
        <p>
          The RTM Price Chart allows you to view the historical rates of gold
          in a graphical format. You can filter by time frame to view trends
          over 1 week, 1 month, or 6 months.
        </p>
      </div>

      <div className="chart-outer-cont">
        <div className="chart-graph-out">
          <div className="filter-gem-outer-with-button">
          <div className="filter-gem-outer-cont">
              <div className="filter-by-gems">
                <label>Filter By Gems</label>
                <p>Gold</p>
              </div>

              <div className="filter-date-range">
                <div className="filter-man-out"> <label>Filter By Date </label></div>
                <div className="filter-label-out">
                  <div className="from-date-out">
                  <div className="from-date">
                <label>From Date</label>
                <input type="date" />
                </div>
                <div className="from-date">
                <label>To Date</label>
                <input type="date" />
                </div>
                </div>
              </div>
            </div>
            </div>
            <div className="filter-create-button">  <button className="filter-button filter">Filter</button>  
            
            
             <button className="filter-button discard"> Discard</button>    </div>

          </div>
         <ChartComponent/>
        </div>
      </div>
    </div>
  );
};

export default PriceChart;
